import { render, staticRenderFns } from "./widgetConfig.vue?vue&type=template&id=601a1739&scoped=true&"
import script from "./widgetConfig.vue?vue&type=script&lang=js&"
export * from "./widgetConfig.vue?vue&type=script&lang=js&"
import style0 from "./widgetConfig.vue?vue&type=style&index=0&id=601a1739&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a1739",
  null
  
)

export default component.exports